import { render, staticRenderFns } from "./SampleReception.vue?vue&type=template&id=554500fc&scoped=true"
import script from "./SampleReception.vue?vue&type=script&lang=js"
export * from "./SampleReception.vue?vue&type=script&lang=js"
import style0 from "./SampleReception.vue?vue&type=style&index=0&id=554500fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554500fc",
  null
  
)

export default component.exports